/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from "prop-types";
import {PERMISSIONS} from '../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../_helpers/UserPermissionSingleton';

class VitalSourceAccessCodeSetup extends Component{
    static get propTypes() {
        return {
            vitalsourceStatuses: PropTypes.object.isRequired,
            collectionId: PropTypes.string,
            generateCompCodeVS: PropTypes.func.isRequired,
            getCompCodeVS: PropTypes.func.isRequired,
            opsAdminCompCode:PropTypes.object.isRequired,
            code:PropTypes.string,
            match: PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            isCompCodeGenerateEnabled: false,
        };
        this.generateCompCodeVS = this.generateCompCodeVS.bind(this);    
    }

    componentDidMount() {
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("VitalSourceAccessCodeSetup");
        }
        const collectionId = this.props.match.params.collId;
        this.props.getCompCodeVS(this.props.match.params.collId);
    }

    generateCompCodeVS(){
        const collectionId = this.props.collectionId;
        setTimeout(() => {
            this.props.generateCompCodeVS(collectionId);
        }, 2000);
        
    }

    render() {
        const {opsAdminCompCode, vitalsourceStatuses} = this.props;
        const isGenerateCompCodeButtonDisabled = UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_comp_code_button);
        const compCodeButtonStyle = isGenerateCompCodeButtonDisabled === true ? 'pe-btn pe-btn--disabled btn_xlarge' : 'pe-btn pe-btn--disabled pe-btn__primary--btn_xlarge';

        return (
            <div className="access-code-setup-page">
                <div className="access-code-notes pe-row">
                    <br/>
                    <p>
                        <strong>You can request a set of Comp Codes for use in accessing the VitalSource ebook after it is set up.</strong></p>
                   
                    <p><strong>The VitalSource ebook will be available as Instant Purchase only in the VitalSource bookshelf. 
                                The Comp Code shown below is meant to be used by Ops Admins for troubleshooting the VitalSource ebook. A set of codes will also be sent to the Instructor at the time they are notified that the VitalSource ebook is ready for students.</strong>
                    </p>
                </div>
                <br/>
                <div className="access-code-pcs pe-row">
                    <button onClick={this.generateCompCodeVS}
                        className={this.state.isCompCodeGenerateEnabled 
                            && vitalsourceStatuses['VITALSOURCE_BOOK_INITIALIZED'].indexOf("SUCCESS") > -1 
                            && vitalsourceStatuses['BOOKBUILD_STATUS'].indexOf("approved") > -1
                            && vitalsourceStatuses['VITALSOURCE_ACKNOWLEDGEMENT'].indexOf("SUCCESS") > -1 ? 'pe-btn__primary--btn_xlarge' : compCodeButtonStyle}
                        disabled={(!this.state.isCompCodeGenerateEnabled || isGenerateCompCodeButtonDisabled || vitalsourceStatuses['COMP_CODE_GENERATION'].indexOf("SUCCESS") > -1) }>GENERATE COMP CODE</button>
                </div>
                <br/>
                <div className="row">
                    <div className="col1">
                        <label className="pe-label--bold">Ops Admin Comp Code:  </label><label className="pe-label">{opsAdminCompCode['code']}</label>
                    </div>
                </div>                   

            </div>
        );
    }
}

export default VitalSourceAccessCodeSetup;



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/VitalSourceAccessCodeSetup.js